import './App.css';


import MuiUnstyledTimePicker from "./MuiUnstyledTimePicker";
import ExistingTimePicker from "./ExistingTimePicker";
import ReactComponentTimePicker from "./ReactComponentTimePicker";
import RSuiteTimePicker from "./RSuiteTimePicker";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Wersja z aktualnego WGJ 2.0:
        <ExistingTimePicker />

        Wersja MUI:
        <MuiUnstyledTimePicker />

        Wersja RSuite:
        <RSuiteTimePicker />

        Wersja ReactComponent:
        <ReactComponentTimePicker />

      </header>
    </div>
  );
}

export default App;